import { render, staticRenderFns } from "./Puzzle.vue?vue&type=template&id=b539be0a&"
import script from "./Puzzle.vue?vue&type=script&lang=js&"
export * from "./Puzzle.vue?vue&type=script&lang=js&"
import style0 from "./Puzzle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports